module.exports = __webpack_public_path__ + "img/littleImg05.9854e24f.gif";